import React, { useState } from "react"
import { Card, CardBody, Table, Input, Row, Col, Modal, ModalHeader, ModalBody, Button } from "reactstrap"
import PropTypes from "prop-types"
import { FILES_URL } from "helpers/url_helper"
import formatDate from "constants/formatDate"

const DeveloperTicketTable = ({ title, tickets }) => {
    const [search, setSearch] = useState("")
    const [filterStatus, setFilterStatus] = useState("All")
    const [selectedDescription, setSelectedDescription] = useState(null)

    const statuses = ["All", ...new Set(tickets.map(t => t.status))]

    const filtered = tickets.filter(t => {
        const matchesSearch =
            t.subject.toLowerCase().includes(search.toLowerCase()) ||
            (t.description || "").toLowerCase().includes(search.toLowerCase())
        const matchesStatus = filterStatus === "All" || t.status === filterStatus
        return matchesSearch && matchesStatus
    })

    return (
        <Col xl={12}>
            <Card>
                <CardBody>
                    {title && <h5 className="mb-3">{title}</h5>}

                    <Row className="mb-3">
                        <Col md={4}>
                            <Input
                                type="text"
                                placeholder="Search tickets"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                        </Col>
                        <Col md={8} className="d-flex justify-content-end">
                            <select
                                className="form-select form-select-sm w-auto"
                                value={filterStatus}
                                onChange={e => setFilterStatus(e.target.value)}
                            >
                                {statuses.map((s, idx) => (
                                    <option key={idx}>{s}</option>
                                ))}
                            </select>
                        </Col>
                    </Row>

                    <Table className="align-middle table-hover table-nowrap mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Created At</th>
                                <th>Subject</th>
                                <th>Description</th>
                                <th>File</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-3">
                                        No tickets found
                                    </td>
                                </tr>
                            ) : (
                                filtered.map((t, idx) => (
                                    <tr key={idx}>
                                        <td>{formatDate(t.created_at)}</td>
                                        <td>{t.subject}</td>
                                        <td style={{ whiteSpace: "pre-wrap", maxWidth: 400 }}>
                                            {t.description ? (
                                                <Button
                                                    color="link"
                                                    className="p-0"
                                                    onClick={() => setSelectedDescription(t.description)}
                                                >
                                                    Read...
                                                </Button>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td>
                                            {t.file_name ? (
                                                <a
                                                    href={`${FILES_URL + t.file_name}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    View
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td>
                                            <span
                                                className={`badge ${t.status === "Open"
                                                        ? "bg-success-subtle text-success"
                                                        : t.status === "In Progress"
                                                            ? "bg-warning-subtle text-warning"
                                                            : t.status === "Closed"
                                                                ? "bg-danger-subtle text-danger"
                                                                : "bg-secondary-subtle text-muted"
                                                    }`}
                                            >
                                                {t.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
            <Modal isOpen={!!selectedDescription} toggle={() => setSelectedDescription(null)} centered>
                <ModalHeader toggle={() => setSelectedDescription(null)}>Description</ModalHeader>
                <ModalBody style={{ whiteSpace: "pre-wrap" }}>{selectedDescription}</ModalBody>
            </Modal>
        </Col>
    )
}

DeveloperTicketTable.propTypes = {
    title: PropTypes.string,
    tickets: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            subject: PropTypes.string,
            description: PropTypes.string,
            file_name: PropTypes.string,
            status: PropTypes.string,
            created_at: PropTypes.string,
        })
    ),
}

export default DeveloperTicketTable